export const LAYOUTS = {
    PRODUCT_LIST: 'product-list',
    PRODUCT_TILES: 'product-tiles',
    ACCENTED_PRODUCT: 'accented-product',
    COVER_IMAGE: 'cover-image',
    '2311-300x600-V1': '2311-300x600-V1',
    '2311-300x600-V2': '2311-300x600-V2',
    '2311-300x600-V3': '2311-300x600-V3',
    '2311-300x600-V4': '2311-300x600-V4',
    '2311-300x600-V5': '2311-300x600-V5',
    '2311-300x600-V6': '2311-300x600-V6',
    '2311-300x600-V7': '2311-300x600-V7',
    '2311-300x600-V8': '2311-300x600-V8',
    '2311-300x600-V9': '2311-300x600-V9',
    '2512-300x600-V10': '2512-300x600-V10',
    '2606-300x600-V12-Evaluation': '2606-300x600-V12-Evaluation',
    '2603-300x600-V2-label-tt': '2603-300x600-V2-label-tt',
    '2603-300x600-V2-label-ig': '2603-300x600-V2-label-ig',
    '2603-300x600-V2-label-local': '2603-300x600-V2-label-local',
    '2603-300x600-V2-label-stock': '2603-300x600-V2-label-stock',
    '2603-300x600-V2-label-sold': '2603-300x600-V2-label-sold',
    '2603-300x600-V4-label-tt': '2603-300x600-V4-label-tt',
    '2603-300x600-V4-label-ig': '2603-300x600-V4-label-ig',
    '2603-300x600-V4-label-local': '2603-300x600-V4-label-local',
    '2603-300x600-V4-label-stock': '2603-300x600-V4-label-stock',
    '2603-300x600-V4-label-sold': '2603-300x600-V4-label-sold'
};

export const LAYOUT_TYPES = {
    FULL_VIEW: 'full-view',
    NO_DESCRIPTION: 'no-description',
    NO_PRICE: 'no-price'
};

export const LOCAL_TRANDING_LAYOUTS = ['2603-300x600-V2-label-local', '2603-300x600-V4-label-local'];

// Layouts that render ONE product at a time (single-product carousel). They skip
// promotion padding and impress only the visible product at mount; the rest fire
// as they come into view. Tested via `isSingleViewLayout`. Add future ones here.
// Mirrors widget-ssr's SINGLE_VIEW_LAYOUTS (@klickly/boa-awa-core).
export const SINGLE_VIEW_LAYOUTS = new Set([LAYOUTS['2606-300x600-V12-Evaluation']]);
